import common from './en-US/common';
import BusinessManagement from './en-US/BusinessManagement';
import PublishingManagement from  './en-US/PublishingManagement';
import StudioManagement from './en-US/StudioManagement';
import metrics from './en-US/metrics';

export default {
  ...common,
  ...BusinessManagement,
  ...PublishingManagement,
  ...StudioManagement, 
  ...metrics,
}; 